import { Card, Col, Row, Typography, Tag, Table } from 'antd';
import moment from "moment";

const { Text } = Typography;

const CreatorPayments = ({ creatorsPayments = [], creatorPaymentsStatus }) => {
    const columns = [
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (text) => `US $${parseFloat(text).toFixed(2)}`,
        },
        {
            title: 'Payment Date',
            dataIndex: 'paymentDate',
            key: 'paymentDate',
            render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            title: 'Reference',
            dataIndex: 'reference',
            key: 'reference',
            render: (reference) => reference ? reference : <Text type="secondary">No reference provided</Text>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text) => <Tag color={'green'} >
                {text.toUpperCase()}
            </Tag>,
        }
    ];

    return <Card className="creator-author-page-card" id="earning-details">
        <Text>Payment History</Text>
        <br />
        <Row>
            <Col xs={24} >
                <Table loading={creatorPaymentsStatus === 'LOADING'} rowKey={record => record.id} columns={columns} dataSource={creatorsPayments} pagination={{ pageSize: 10 }} />
            </Col>
        </Row>
    </Card>
}

export default CreatorPayments;